import { connect } from 'react-redux';
import AddArt from './add_art';
import { closePanel } from '../../actions/panel';
import { togglePin } from '../../actions/pin';

const mapStateToProps = ({ pin }) => pin;

export default connect(mapStateToProps, {
  closePanel,
  togglePin
})(AddArt);
